var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/empty-wallet"
  }, /*#__PURE__*/React.createElement("g", {
    id: "empty-wallet"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.7997 5.26666V10.3333H17.7997V5.26666C17.7997 4.90666 17.4797 4.73333 17.2663 4.73333C17.1997 4.73333 17.133 4.74666 17.0663 4.77333L6.49301 8.76C5.78634 9.02666 5.33301 9.69333 5.33301 10.4533V11.3467C4.11967 12.2533 3.33301 13.7067 3.33301 15.3467V10.4533C3.33301 8.86666 4.30634 7.45333 5.78634 6.89333L16.373 2.89333C16.6663 2.78666 16.973 2.73333 17.2663 2.73333C18.5997 2.73333 19.7997 3.81333 19.7997 5.26666Z",
    fill: "#A29261"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.6663 19.3333V20.6667C28.6663 21.0267 28.3863 21.32 28.0129 21.3333H26.0663C25.3596 21.3333 24.7196 20.8133 24.6663 20.12C24.6263 19.7067 24.7863 19.32 25.0529 19.0533C25.2929 18.8 25.6263 18.6667 25.9863 18.6667H27.9996C28.3863 18.68 28.6663 18.9733 28.6663 19.3333Z",
    fill: "#A29261"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.973 17.2667H27.333C28.0663 17.2667 28.6663 16.6667 28.6663 15.9333V15.3467C28.6663 12.5867 26.413 10.3333 23.653 10.3333H8.34634C7.21301 10.3333 6.17301 10.7067 5.33301 11.3467C4.11967 12.2533 3.33301 13.7067 3.33301 15.3467V24.32C3.33301 27.08 5.58634 29.3333 8.34634 29.3333H23.653C26.413 29.3333 28.6663 27.08 28.6663 24.32V24.0667C28.6663 23.3333 28.0663 22.7333 27.333 22.7333H26.173C24.893 22.7333 23.6663 21.9467 23.333 20.7067C23.053 19.6933 23.3863 18.72 24.053 18.0667C24.5463 17.56 25.2263 17.2667 25.973 17.2667ZM18.6663 17H9.33301C8.78634 17 8.33301 16.5467 8.33301 16C8.33301 15.4533 8.78634 15 9.33301 15H18.6663C19.213 15 19.6663 15.4533 19.6663 16C19.6663 16.5467 19.213 17 18.6663 17Z",
    fill: "#A29261"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyWallet);
export default __webpack_public_path__ + "static/media/empty-wallet.843e501a24e39fcea419774a38df45df.svg";
export { ForwardRef as ReactComponent };